module.exports = __webpack_public_path__ + "static/media/pause.ab77eab6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/pause.svg
// module id = 1163
// module chunks = 0